import React from 'react'

function Terms() {
  return (
    <>
      <head>
    <meta charset="UTF-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <title>Terms And Conditions</title>
    <link rel="stylesheet" href="<%= process.env.APP_URL %>/css/main.css"/>
    <link rel="preconnect" href="https://fonts.googleapis.com"/>
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
    <link href="https://fonts.googleapis.com/css2?family=K2D:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap" rel="stylesheet"/>
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
   
     <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous"/>
     <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js" integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM" crossorigin="anonymous"></script>
    </head>
    <body></body>
    <body>
    <main>
        <section class="wrapper-body mt-4">
            
                <div class="container">
                    <div class="row wrapper-container mb-4">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    
                                    <div class="head_Info my-3">
                                        <h5>Who This Agreement Applies To:</h5>
                                        <p>This agreement ("Terms") applies to you or the entity you represent "you" and Swizzle Innovations Pvt. Ltd. ("Swizzle") regarding your use of Swizzle's online business productivity and collaboration software (" Services"). By accessing or using our Services, you agree to be bound by these Terms. If you don't agree, please don't use our Services.</p>
                                    </div>
                                    <ol>
                                        <li>
                                            <h5>Using the Services:</h5>
                                            <p>a.Eligibility: You must be at least 18 years old or the legal age of majority in your jurisdiction to use the Services.</p>
                                            <p>b. Registration: Some features require an account. You agree to provide accurate and complete information during registration and keep it updated.</p>
                                            <p>c. Access and Security: You're responsible for keeping your account information confidential and preventing unauthorized access. Please notify us immediately if you suspect unauthorized activity.</p>
                                        </li>
                                        <li>
                                            <h5>Your Content:</h5>
                                            <p>a. Ownership: You own any content you upload to the Services ("User Content").</p>
                                            <p>b. License: By uploading User Content, you grant Swizzle a worldwide, non-exclusive, royalty-free license to use, reproduce, distribute, modify, publicly display, and perform it for operating and improving the Services.</p>
                                           
                                        </li>
                                        
                                        <li>
                                            <h5>Prohibited Conduct:</h5>
                                            <p>You agree not to:</p>
                                            <ul>
                                                <li>Use the Services for any illegal, harmful, or unauthorized purpose.</li>
                                                <li>Interfere with or disrupt the Services. Attempt unauthorized access to the Services or related systems.</li>
                                                <li>Reverse engineer, decompile, or disassemble any part of the Services.</li>
                                            </ul>
            
                                        </li>
                                        <li>
                                            <h5>Intellectual Property:</h5>
                                            <p>Swizzle owns or licenses all intellectual property rights in the Services, including trademarks, copyrights, and patents. You may not use them without our prior written consent.</p>
                                        </li>
                                        <li>
                                            <h5>Termination:</h5>
                                            <p>We may suspend or terminate your access to the Services at any time and for any reason, with or without notice. Upon termination, your rights under these Terms cease, and you must stop using the Services.</p>
                                        </li>
                                        <li>
                                            <h5>Changes to Terms:</h5>
                                            <p>We may update these Terms from time to time to reflect changes in the Services or for other legal reasons. We will notify you of any material changes by posting the revised Terms on our website or through other means. </p>
                                        </li>
                                        <li>
                                            <h5>Governing Law and Jurisdiction:</h5>
                                            <p>These Terms are governed by the laws of the state of Kerala, India. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts in Thiruvananthapuram, Kerala.</p>
                                        </li>
                                        
                                       
                                    </ol>
                                    <div class="head_Info my-3">
                                        <h3>Cancellation Policy</h3>
                                            <p>This Cancellation Policy ("Policy") applies to the Software-as-a-Service (SaaS) applications and related services provided by Swizzle Innovations Private Limited, located at TC 29/2637-1, 8th Floor, Carmel Towers, Cotton Hill, Vazhuthacaud, Thiruvananthapuram, Kerala, India ("Swizzle Innovations," "we," "our," or "us"). By using our Services, you agree to comply with and be bound by this Policy. If you do not agree with this Policy, please do not use our Services.</p>
                                    </div>
                                    <ol>
                                        <li>
                                            <h5>Cancellation</h5>
                                            <p>1.1. Cancellation Process: You may cancel your subscription to our Services at any time by following the cancellation process outlined in your account settings or by contacting our customer support team by clicking here.</p>
                                            <p>1.2. Immediate Cancellation: Upon submitting a cancellation request, your access to our Services will be terminated immediately, and you will no longer be billed for future subscription periods.</p>
                                        </li>
                                        <li>
                                            <h5>No Refunds</h5>
                                            <p>2.1. Non-Refundable: Please note that we do not offer refunds for canceled subscriptions. All fees paid for subscription services are non-refundable.</p>
                                           
                                        </li>
                                        <li>
                                            <h5>Suspension or Termination</h5>
                                            <p>3.1. Non-Payment: Failure to pay for your subscription may result in the suspension or termination of your account and access to our Services.</p>
                                           
                                        </li>
                                        <li>
                                            <h5>Changes to the Cancellation Policy</h5>
                                            <p>We may update this Cancellation Policy from time to time to reflect changes in our Services or for other operational, legal, or regulatory reasons. We will notify you of any material changes by posting the revised Policy on our website or through other means.</p>
                                        </li>
                                        <li>
                                            <h5>Contact Us</h5>
                                            <p>If you have any questions or concerns regarding this Cancellation Policy, please contact us by <a href="https://swizzleup.com/contact" target="_blank" class="text-decoration-none primary">clicking here.</a></p>
                                            <p>By using our Services, you acknowledge that you have read and understood this Cancellation Policy and agree to comply with and be bound by it.</p>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center mt-3">
                        <small>&copy; {new Date().getFullYear()} SwizzlePay. All rights reserved.</small>

                        </div>
                    </div>
                </div>
            
            </section>
            
            
    </main>
    
</body>
</>
  )
}

export default Terms